/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */
import { AlertColor } from '@mui/material';

/**
 * Notification types that equals to MUI AlertColor types, but we can extend it if needed
 */
export const NotificationTypes = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

/**
 * Type for notification, based on the keys of NotificationTypes
 */
export type NotificationType = (typeof NotificationTypes)[keyof typeof NotificationTypes];

/**
 * Default duration for the snackbar (in milliseconds)
 */
export const DEFAULT_SNACKBAR_DURATION = 5000;

/**
 * Maps notification types to MUI AlertColors
 */
export const getAlertColor = (type: NotificationType): AlertColor => {
  const isValidType = Object.values(NotificationTypes).includes(type);
  if (!type || !isValidType) {
    return 'info';
  }

  return type as AlertColor;
};
